import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import {useActiveProductId} from '../../../shellRemote';
import type {PromptContextParams} from './buildPromptContext';
import {useAriaPageScope} from './useAriaPageScope';

/**
 * usePromptContextParams returns the page scope, app path, query string, and
 * product ID that every user message derives its page state from.
 */
export function usePromptContextParams(): PromptContextParams {
  const scope = useAriaPageScope();
  const {pathname: appPath, search} = useLocation();
  const productId = useActiveProductId();
  return useMemo(
    () => ({...scope, appPath, search, productId}),
    [scope, appPath, search, productId]
  );
}
